module.exports = __webpack_public_path__ + "static/media/tony.356f86a2.gif";